import { schema } from 'normalizr';

import { ActivityContext } from '@lib/resources/types';

import appointmentsResource from './appointmentsResource';
import availabilitiesResource from './availabilitiesResource';
import createResource from './createResource';
import patientFormTemplatesResource from './patientFormTemplatesResource';
import patientsResource from './patientsResource';
import waitlistsResource from './waitlistsResource';

const activityContextsResource = createResource<ActivityContext>({
  key: 'activityContexts',
  url: 'NO-OP',
  lookups: {
    appointment: appointmentsResource,
    availability: availabilitiesResource,
    patient: patientsResource,
    patientFormTemplate: patientFormTemplatesResource,
    waitlists: {
      ...waitlistsResource,
      schema: new schema.Array(waitlistsResource.schema),
    },
  },
});

export default activityContextsResource;
